'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const forEach = require('lodash/forEach');
const get = require('lodash/get');
const uuid = require('uuid');
import { Row, Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
const urljoin = require('url-join');
const Moment = require('moment');
const _ = {
    filter: require('lodash/filter'),
};

const PermissionsUtil = require('../../../app/shared/PermissionsUtil');
const FeatureUtil = require('../../../app/shared/FeatureUtil');
const Globals = require('../../../app/globals');
const Strings = require('../../../app/shared/Strings');
const verUtil = require('../util/version.js');
const ServerRequest = require('../actions/request');
const SignInStore = require('../stores/SignInStore');
const ActivityActions = require('../actions/ActivityActions');
const ActivityStore = require('../stores/activity_store_reflux');
const TemplateStore = require('../stores/template_store_reflux');
const AnalyticsStore = require('../stores/AnalyticsStore');
const AnalyticsActions = require('../actions/AnalyticsActions');
const OrganizationStore = require('../stores/OrganizationStore');
const OrganizationActions = require('../actions/OrganizationActions');
const AssetUtil = require('../util/asset');
const StringUtil = require('../../../app/shared/StringUtil');
const TimeUtil = require('../../../app/shared/TimeUtil');
import Navigator from '../Navigator';
import MainNav from './DashboardNew/Menu/MainNav';
import SubNav from './nav/SubNav';
import BackButton from './nav/BackButton';
import SideNav from './nav/SideNav';
import ConfirmModal from './modal/ConfirmModal';
import ForceUnlockModal from './modal/ForceUnlockModal';
import ThreeModal from './modal/ThreeModal';
import SingleInputModal from './modal/SingleInputModal2';
import SelectProjectModal from './modal/SelectProjectModal';
import DateString from './common/DateString';
import WarningBox from './common/WarningBox';
import ActivitySavesTable from './activity/ActivitySavesTable';
import AssetImage from './common/AssetImage';
import SingleAssetInput from './common/SingleAssetInput';
import CopyActivityModal from './modal/CopyActivityModal';
import GoogleClassroomCreateUI from './activity/GoogleClassroomCreateUI';
import LocalAssignmentCreateUI  from './activity/LocalAssignmentCreateUI';
import ActivityStatsCharts from './analytics/ActivityStatsCharts';
import UserFullName from './user/UserFullName';
import UserDisplayName from './user/UserDisplayName';
import Tooltip from './common/Tooltip';
import ActivityDescriptionEditor from './activity/ActivityDescriptionEditor';
import ActivityDisplayNameEditor from './activity/ActivityDisplayNameEditor';
import ActivityPlayButtonTextEditor from './activity/ActivityPlayButtonTextEditor';
import ManageActivityTagsModal from './modal/ManageActivityTagsModal';
import PublishActivityModal from './modal/PublishActivityModal';
import ActivityValidationReportModal from './modal/ActivityValidationReportModal';
import ActivityShortCourseMetadataModal from './modal/ActivityShortCourseMetadataModal';
import WithChannelData from './DataHOCs/WithChannelData';
import WithProjectData from './DataHOCs/WithProjectData';
import WithDocumentVisible from './DataHOCs/WithDocumentVisible';
import WithActivityLockPoll from './DataHOCs/WithActivityLockPoll';
import { ActivityBreadCrumbs } from './nav/NavBreadCrumbs';
import StackImportMergeModal from './modal/StackImportMergeModal';
import ConfirmPhraseModal from './modal/ConfirmPhraseModal';
import DateTimePicker from './common/DateTimePicker2';

const propTypes = {
    history: PropTypes.object.isRequired,
    activityId: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    channelId: PropTypes.string.isRequired,
    documentVisible: PropTypes.bool.isRequired,
    activityLock: PropTypes.object.isRequired,
    onToggleActivityLockPoll: PropTypes.func.isRequired,
    projectStoreState: PropTypes.shape({
        initialized: PropTypes.bool.isRequired,
        project: PropTypes.object.isRequired
    }).isRequired,
    channelStoreState: PropTypes.shape({
        initialized: PropTypes.bool.isRequired,
        channel: PropTypes.object.isRequired
    }).isRequired,
};

const defaultProps = {};

class ActivityView extends React.Component {
    constructor(props) {
        super(props);
        const activityStoreState = ActivityStore.getStateActivity(props.activityId, props.projectId, props.channelId);
        let templateStoreState = { initialized: false };
        let activityImgUrl;
        if (activityStoreState.initialized) {
            const moduleID = activityStoreState.activity.module_id;
            templateStoreState = TemplateStore.getStateTemplate(moduleID);
            activityImgUrl = activityStoreState.activity.meta_data.image_url;
        }
        const orgStoreState = OrganizationStore.getStateOrganization(props.channelId);
        const accountFeatures = orgStoreState.orgAccountFeatures || null;

        this.state = {
            signInStoreState: SignInStore.getState(),
            templateStoreState: templateStoreState,
            activityStoreState: activityStoreState,
            activityImgUrl: activityImgUrl,
            imageUpdateActionID: null,
            modalData: null,
            modalState: {
                archiveActivity: false,
                addUserProject: false,
                renameActivity: false,
                publishActivity: false,
                unpublishActivity: false,
                transferActivity: false,
                copyActivity: false,
                activityTags: false,
                autosaveFound: false,
                confirmAutosaveDelete: false,
                forceUnlock: false,
                stackImport: false,
            },
            modalAction: {},
            showValdiationModalForVesion: null,
            avgTimePlayed: 0,
            totalCompleted: 0,
            avgScore: 0,
            timePlayedGraphData: [],
            completionGraphData: [],
            scoreGraphData: [],
            activityLaunchCount: 0,
            shareStartedTotal: 0,
            sharesUniqueMtd: 0,
            devDisablePolling: false,
            showAssignmentCreateUI: '',
            saveHistoryDetailLevel: 0,
            transferActivityActionId: null,
            transferActivityError: null,
            unpublishActionId: null,
            unpublishError: null,
            importStacks: [],
            sharingActionId: null,
            updatedShareExpiration: null,
            shareExpirationDirty: false,
            customActivityExportState: {
                actionID: null,
                pending: false,
                csv_data: null,
            },
            accountFeatures,
        };

        this.refreshActivity = this.refreshActivity.bind(this);
        this.getStats = this.getStats.bind(this);
        this.getImportStacks = this.getImportStacks.bind(this);
        this.archiveActivityHandler = this.archiveActivityHandler.bind(this);
        this.renameActivityHandler = this.renameActivityHandler.bind(this);
        this.transferActivityHandler = this.transferActivityHandler.bind(this);
        this.copyActivityHandler = this.copyActivityHandler.bind(this);
        this.publish = this.publish.bind(this);
        this.onUnpublish = this.onUnpublish.bind(this);
        this.confirmPublish = this.confirmPublish.bind(this);
        this.preview = this.preview.bind(this);
        this.getAutosaveMessageText = this.getAutosaveMessageText.bind(this);
        this.getAutosaveButtonData = this.getAutosaveButtonData.bind(this);
        this.edit = this.edit.bind(this);
        this.review = this.review.bind(this);
        this.analytics = this.analytics.bind(this);
        this.backHandler = this.backHandler.bind(this);
        this.viewAssignment = this.viewAssignment.bind(this);
        this.selectAllHandler = this.selectAllHandler.bind(this);
        this.noOp = this.noOp.bind(this);
        this.updateImage = this.updateImage.bind(this);
        this.updateImageOnError = this.updateImageOnError.bind(this);
        this.forceUnlock = this.forceUnlock.bind(this);
        this.toggleDisablePolling = this.toggleDisablePolling.bind(this);
        this.showGoogleClassroomCreateUI = this.showGoogleClassroomCreateUI.bind(this);
        this.showLocalAssignmentCreateUI = this.showLocalAssignmentCreateUI.bind(this);
        this.hideAssignmentCreateUI = this.hideAssignmentCreateUI.bind(this);
        this.setValidationModalVersion = this.setValidationModalVersion.bind(this);
        this.gotoActivityAnalytics = this.gotoActivityAnalytics.bind(this);
        this.gotoActivityQla = this.gotoActivityQla.bind(this);
        this.handle_EDL_export = this.handle_EDL_export.bind(this);
        this.gotoMetaTagsView = this.gotoMetaTagsView.bind(this);
        this.renderCreateAssignmentUI = this.renderCreateAssignmentUI.bind(this);
        this.enableShare = this.enableShare.bind(this);
        this.updateShareExpiration = this.updateShareExpiration.bind(this);
        this.doShareChanges = this.doShareChanges.bind(this);
        this._showModal = this._showModal.bind(this);
        this._hideModal = this._hideModal.bind(this);
        this._addActionIdToModal = this._addActionIdToModal.bind(this);
        this._getNewHiddenModalStateForAction = this._getNewHiddenModalStateForAction.bind(this);

        this.unsubscribes = [
            SignInStore.listen(this.onSignInStoreChange.bind(this)),
            TemplateStore.listen(this.onTemplateStoreChange.bind(this)),
            ActivityStore.listen(this.onActivityStoreChange.bind(this)),
            AnalyticsStore.listen(this.onAnalyticsStoreChange.bind(this)),
            OrganizationStore.listen(this.onOrgStoreChange),
        ];
    }

    componentDidMount() {
        if (this.props.channelStoreState.initialized && !this.props.channelStoreState.channel) {
            Navigator.goToDashboardAuthorView.bind(this, this.props.history, Globals.view_tokens.dashboard.AUTHORING);
            return;
        }

        if (this.props.projectStoreState.initialized && !this.props.projectStoreState.project) {
            Navigator.goToDashboardAuthorView.bind(this, this.props.history, Globals.view_tokens.dashboard.AUTHORING);
            return;
        }

        this.refreshActivity(true);
        this.updateInterval = window.setInterval(this.refreshActivity, 30000);
        this.getStats();
        this.getImportStacks();
        // this.statsInterval = window.setInterval(self.getStats, 60000);
        if (!this.state.accountFeatures) {
            let accountFeatures_actionId = uuid.v4();
            this.setState({accountFeatures_actionId},()=>{
                const orgId = this.props.channelId;
                OrganizationActions.getOrgAccountFeatures(accountFeatures_actionId, orgId);
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        //getStats immediately upon init
        if (!prevState.activityStoreState.initialized && this.state.activityStoreState.initialized) {
            this.getStats();
        }
    }

    componentWillUnmount() {
        window.clearInterval(this.updateInterval);
        // window.clearInterval(this.statsInterval);
        this.unsubscribes.forEach(u => u());
    }

    onSignInStoreChange(state) {
        const self = this;
        this.setState({ signInStoreState: state }, () => {
            self.getImportStacks();
        });
    }

    onTemplateStoreChange(state) {
        if (state.initialized && this.state.activityStoreState.activity) {
            const moduleID = this.state.activityStoreState.activity.module_id;
            this.setState({templateStoreState: TemplateStore.getStateTemplate(moduleID)})
        }
        else {
            this.setState({ templateStoreState: { initialized: false } });
        }
    }

    onActivityStoreChange(state) {
        const newActivityStoreState = ActivityStore.getStateActivity(this.props.activityId, this.props.projectId, this.props.channelId);
        // the activity store state has been initialized (received ALL activity info)
        // and an activity with this.state.activityID is not present, navigate away
        if (newActivityStoreState.initialized && !newActivityStoreState.activity) {
            this.backHandler();
            return;
        }

        let modalsUpdated = false; // prevent _getNewHiddenModalStateForAction from being called if this handler takes care of modal state
        let newState = { activityStoreState: newActivityStoreState };
        if (newActivityStoreState.activity) {
            newState = {
                ...newState,
                templateStoreState: TemplateStore.getStateTemplate(newActivityStoreState.activity.module_id),
                activityImgUrl: newActivityStoreState.activity.meta_data.image_url
            };
        }

        if (get(this.state.modalAction, 'archiveActivity', null) === state.action.id) {
            if (!state.action.error) { // archive success
                this.backHandler();
                return;
            }
        }

        if (this.state.imageUpdateActionID === state.action.id) {
            newState = {
                ...newState,
                imageUpdateActionID: null
            };
        }

        if (this.state.transferActivityActionId === state.action.id) {
            if (!!state.action.error) {
                newState = {
                    ...newState,
                    transferActivityActionId: null,
                    transferActivityError: state.action.error,
                }
            }
            else {
                newState = {
                    ...newState,
                    transferActivityActionId: null,
                    transferActivityError: null,
                    modalState: { ...this.state.modalState, transferActivity: false },
                };
                modalsUpdated = true;
            }
        }

        if (this.state.unpublishActionId === state.action.id) {
            if (!!state.action.error) {
               newState = {
                    ...newState,
                    unpublishActionId: null,
                    unpublishError: state.action.error,
                }
            }
            else {
                newState = {
                    ...newState,
                    unpublishActionId: null,
                    unpublishError: null,
                    modalState: { ...this.state.modalState, unpublishActivity: false },
                };
                modalsUpdated = true;
            }
        }

        if (this.state.sharingActionId === state.action.id) {
            if (!!state.action.error) {
                newState = {
                    ...newState,
                    sharingActionId: null,
                };
            }
            else {
                newState = {
                    ...newState,
                    sharingActionId: null,
                    updatedShareExpiration: null,
                    shareExpirationDirty: false,
                };
            }
        }

        if (newActivityStoreState.activityStats) {
           newState = {
                ...newState,
                ...newActivityStoreState.activityStats,
            };
        }
        

        if (typeof newActivityStoreState.activityLaunchCounts === 'number') {
           newState = {
                ...newState,
                activityLaunchCount: newActivityStoreState.activityLaunchCounts
            };
        }

        if (typeof newActivityStoreState.shareStartedTotal === 'number') {
            newState = {
                 ...newState,
                 shareStartedTotal: newActivityStoreState.shareStartedTotal
             };
         }

         if (typeof newActivityStoreState.sharesUniqueMtd === 'number') {
            newState = {
                 ...newState,
                 sharesUniqueMtd: newActivityStoreState.sharesUniqueMtd
             };
         }

        if (get(this.state.modalAction, 'shortCourseMetadata', null) === state.action.id) {
            // we want error state.
            newState = { ...newState, modalState: { ...this._getNewHiddenModalStateForAction(state.action) } };
        }
        else if ( // optimization
            !modalsUpdated
            && !!state.action
            && !!state.action.id
            && !state.action.error
            && state.action.id !== 'activity-poll'
            && state.action.id !== 'activity-lock-poll'
            && state.action.id !== 'activity-saves-poll'
        ) {
            newState = { ...newState, modalState: { ...this._getNewHiddenModalStateForAction(state.action) } };
        }

        this.setState(newState);
    }

    onAnalyticsStoreChange(storeState) {
        let xs = this.state.customActivityExportState;
        if (storeState.action.id === xs.actionID) {
            const _activity = this.state.activityStoreState.activity;
            let channelId = this.props.channelId;
            let activityId = _activity.id;
            let version = xs.version || _activity.latest_published_version;
            let data;
            if ((xs.channelId === channelId) && (xs.activityId === activityId) && (xs.version === version)) {
                data = AnalyticsStore.getCustomAnalyticsState(channelId,activityId,version);
            }
            if (data) {
                this.setState({
                    customActivityExportState: {
                        actionID: null,
                        channelId: this.props.channelId,
                        activityId: _activity.id,
                        version: version,
                        pending: false,
                        csv_data: data.csvData,
                    }
                });
            }
            else {
                // something changed while we were waiting for the result.
                this.clearOldCsvData();
                this.setState({
                    customActivityExportState: {
                        actionID: null,
                        pending: false,
                        csv_data: null,
                    }
                });
            }
        }
    }
    
    onOrgStoreChange=(state)=>{
        const orgId = this.props.channelId;
        if (state.action.id === this.state.accountFeatures_actionId) {
            const orgStoreState = OrganizationStore.getStateOrganization(orgId);
            const accountFeatures = orgStoreState.orgAccountFeatures || {};
            if (state.action.error) {
                console.log("error getting org account features",state.action.error);
            }
            this.setState({accountFeatures, accountFeatures_actionId: null});
        }
    }

    refreshActivity(init=false) {
        if (
            !init
            && (!this.props.documentVisible || this.state.devDisablePolling)
        ) {
            return;
        }

        ActivityActions.getActivity(
            'activity-poll',
            {
                activityId: this.props.activityId,
                projectId: this.props.projectId,
                channelId: this.props.channelId
            }
        );
    }

    getStats() {
        if (!this.props.documentVisible || this.state.devDisablePolling) {
            return;
        }

        // TODO don't do this again if we have charts

        if (
            this.state.activityStoreState.initialized &&
            this.state.activityStoreState.activity &&
            !!this.state.activityStoreState.activity.latest_published_version
        ) {
            ActivityActions.getActivityStats(
                'activity-stats',
                {
                    activityId: this.props.activityId,
                    novaActId: this.state.activityStoreState.activity.activity_id,
                }
            );
        }
    }

    getImportStacks() {
        if (
            this.state.signInStoreState.initialized
            && this.state.signInStoreState.userInfo.admin
        ) {
            ServerRequest.makeRequest('/authoring/import_stacks', 'POST')
                .then((res) => {
                    this.setState({ importStacks: res });
                })
                .catch((err) => {
                    console.error('import_stacks error', err);
                    this.setState({ importStacks: [] });
                });
        }
    }

    archiveActivityHandler() {
        window.clearInterval(this.updateInterval);
        // window.clearInterval(this.statsInterval);

        const actionID = uuid.v4();
        this._addActionIdToModal("archiveActivity", actionID, () => {
            ActivityActions.archiveActivity(actionID, {
                activityID: this.props.activityId,
                projectID: this.props.projectId
            });
        });
    }

    renameActivityHandler(newName) {
        const actionID = uuid.v4();
        this._addActionIdToModal("renameActivity", actionID, () => {
            ActivityActions.renameActivity(actionID, {
                activityID: this.props.activityId,
                projectID: this.props.projectId,
                name: newName
            });
        });
    }

    transferActivityHandler(toProjectId) {
        const actionId = uuid.v4();
        this.setState({ transferActivityActionId: actionId }, () => {
            ActivityActions.transferActivity(actionId, {
                activityId: this.props.activityId,
                toProjectId: toProjectId,
                fromProjectId: this.props.projectId
            });
        })

        //todo: transition to new project destination?
    }

    copyActivityHandler(name, projectId, copyMetaTags) {
        const actionId = uuid.v4();
        this._addActionIdToModal("copyActivity", actionId, () => {
            ActivityActions.copyActivity(actionId, {
                activityId: this.props.activityId,
                name: name,
                toProjectId: projectId,
                fromProjectId: this.props.projectId,
                copyMetaTags: copyMetaTags,
            });
        });
    }

    submitShortCourseMetaDataHandler=(changes)=>{
        const actionId = uuid.v4();
        this._addActionIdToModal("shortCourseMetadata", actionId, () => {
            ActivityActions.updateActShortCourseMetaData(actionId,this.props.activityId,changes);
        });
    }

    publish() {
        this._showModal("publishActivity");
    }

    confirmPublish(message) {
        const actionID = uuid.v4();
        this._addActionIdToModal("publishActivity", actionID, () => {
            ActivityActions.publishActivity(actionID, {
                activityID: this.props.activityId,
                message: message
            });
        });

    }

    onUnpublish() {
        const unpublishActionId = uuid.v4();
        this.setState({ unpublishActionId: unpublishActionId,  unpublishError: null }, () => {
            ActivityActions.unpublish(unpublishActionId, { activityId: this.props.activityId });
        });
    }

    preview() {
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/activity/${this.props.activityId}/preview`);
    }

    getAutosaveMessageText(confirmingDeleteAutosave) {
        if (this.state.activityStoreState && this.state.activityStoreState.activity) {
            var autoSaveInfo = this.state.activityStoreState.activityAutoSaveInfo;
            if (autoSaveInfo && autoSaveInfo.moreRecent) {
                // Example desired message: "Autosave created by Dave on 4/11/2018 at 3:30:00 PM found. What would you like to do?"
                const day_text = new Date(autoSaveInfo.saveDate).toLocaleDateString();
                const time_text = new Date(autoSaveInfo.saveDate).toLocaleTimeString();
                const by_text = autoSaveInfo.userName ? (" by " + autoSaveInfo.userName) : "";
                let prefix = "Autosave created" + by_text + " on " + day_text + " at " + time_text + " found."; 
                if (confirmingDeleteAutosave) {
                    return  prefix + " Are you sure you wish to delete this autosave?";
                }
                return prefix + " What would you like to do?";
            }
        }
        if (confirmingDeleteAutosave) {
            return  "Are you sure you wish to delete this autosave?";
        }
        return 'What would you like to do?';
    }

    getAutosaveButtonData(confirmingDeleteAutosave) {
        const autoSaveInfo = this.state.activityStoreState.activityAutoSaveInfo
        const buttonData = [
            {
                text: "Load Autosave",
                handler: () => {
                    this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/activity/${this.props.activityId}/edit/${autoSaveInfo.version}`);
                },
                disabled: confirmingDeleteAutosave,
                variant: confirmingDeleteAutosave ? 'secondary' : undefined,
            },
            {
                text: confirmingDeleteAutosave ? "Confirm Discard" : "Discard Autosave",
                variant: confirmingDeleteAutosave ? 'danger' : undefined,
                handler: () => {
                    if (confirmingDeleteAutosave) {
                        ActivityActions.deleteAutosave(uuid.v4(), {
                            projectId: this.props.projectId,
                            activityId: this.props.activityId,
                            version: autoSaveInfo.version
                        });
                        this._hideModal("confirmAutosaveDelete", () => {
                            this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/activity/${this.props.activityId}/edit`);
                        });
                    }
                    else {
                        this._hideModal('autosaveFound',()=>{
                            this._showModal('confirmAutosaveDelete');
                        });
                    }
                },
            },
            {
                text: "Cancel",
                handler: () => { 
                    if (confirmingDeleteAutosave) {
                        this._hideModal('confirmAutosaveDelete',()=>{
                            this._showModal('autosaveFound');
                        });
                    }
                    else {
                        this._hideModal("autosaveFound");
                    }
                },
            }
        ];
        return buttonData;
    }

    edit() {
        if (this.state.activityStoreState && this.state.activityStoreState.activityAutoSaveInfo) {
            const autoSaveInfo = this.state.activityStoreState.activityAutoSaveInfo;
            if (autoSaveInfo && autoSaveInfo.moreRecent) {
                this._showModal('autosaveFound');
                return;
            }
            // else fall thru to normal route
        }

        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/activity/${this.props.activityId}/edit`);
    }

    review() {
        // only review most recent saved version. no reviewing autosaves.
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/activity/${this.props.activityId}/review`);
    }

    analytics() {
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/activity/${this.props.activityId}/analytics`);
    }

    backHandler() {
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}#${this.props.activityId}`);
    }
    
    // called if the template has a post_publish page (for example, to synthesize voices)
    postPublishHandler=()=>{
        // piggy back on preview view
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/activity/${this.props.activityId}/preview?post_publish=1`); 
    }

    viewAssignment(resultRoute) {
        // use window.location.href rather than router due to LTI client split from main
        window.location.href = resultRoute;
    }

    selectAllHandler(e) {
        e.target.setSelectionRange(0, e.target.value.length);
    }

    noOp(e) {
        return;
    }

    updateImage(params, files) {
        const actionID = uuid.v4();
        this.setState({ imageUpdateActionID: actionID }, () => {
            ActivityActions.addActivityImage(
                actionID,
                {
                    ...params,
                    activityId: this.props.activityId,
                    projectId: this.props.projectId,
                },
                files
            );
        });
    }

    updateImageOnError(errorMsg) {
        window.alert(errorMsg || 'Error');
    }

    forceUnlock() {
        this._showModal("forceUnlock");
    }

    toggleDisablePolling() {
        this.setState({ devDisablePolling: !this.state.devDisablePolling }, () => {
            this.props.onToggleActivityLockPoll(this.state.devDisablePolling);
        });
    }

    showGoogleClassroomCreateUI() {
        this.setState({ showAssignmentCreateUI: 'gc' });
    }

    showLocalAssignmentCreateUI() {
        this.setState({ showAssignmentCreateUI: 'mzl' });
    }

    hideAssignmentCreateUI() {
        this.setState({ showAssignmentCreateUI: '' });
    }

    setValidationModalVersion(version) {
        this.setState({ showValdiationModalForVesion: version });
    }

    gotoActivityAnalytics() {
        this.props.history.push(`/analytics/${this.props.channelId}/${this.props.projectId}/activities/${this.props.activityId}`);
    }

    gotoActivityQla() {
        this.props.history.push(`/analytics/${this.props.channelId}/${this.props.projectId}/activities/${this.props.activityId}/qla`);
    }

    gotoMetaTagsView() {
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/activity/${this.props.activityId}/meta_tags`);
    }
    
    clearOldCsvData() {
        if (this.state.customActivityExportState.csv_data) {
            AnalyticsActions.clearChannelCSV(uuid.v4(),{
                id: this.props.channelId,
                csv_filename: this.state.customActivityExportState.csv_data.csv_filename
            })
        }
    }
    
    handle_EDL_export() {
        const _activity = this.state.activityStoreState.activity;
        const channelId = this.props.channelId;
        const activityId = _activity.id;
        let xs = this.state.customActivityExportState;
        const version = xs.version || _activity.latest_published_version;
        if (xs.pending || xs.csv_data) { // already in progress or already completed
            if ((xs.channelId === channelId) && (xs.activityId === activityId) && (xs.version === version)) {
                return; 
            }
            // else properties have changed and this is a new export
        }
        const actionID = uuid.v4();
        this.clearOldCsvData();
        this.setState({
            customActivityExportState: {
                actionID: actionID,
                channelId,
                activityId,
                version,
                pending: true,
                csv_data: null,
            }
        },
        () => {
            AnalyticsActions.getChannelActivityCustomAnalytics(actionID, {
                channelId, 
                activityId,
                version,
            }); 
        });
       
        
        // User.loggedInRequest('post', '/analytics/channel/:channel_id/activity/:activity_id/custom_analytics_csv', [globals.users.type.LOCAL], Promise.method(function(req, res) {

    }

    renderCreateAssignmentUI(activityID, activityVersion, title, channelUserPermissions, projectUserPermissions, channelFeatures) {
        var hasCred = true; // no longer need: (userInfo.key && userInfo.secret) ? true : false;
        var missingCredentialsText = 'To access this feature please contact Muzzy Lane at authorsupport@muzzylane.com';
        var toolTip = '';
        if (!hasCred) {
            toolTip = missingCredentialsText;
        }
        switch(this.state.showAssignmentCreateUI) {
            case 'gc':
                return (
                    <GoogleClassroomCreateUI
                        activityID={activityID}
                        activityVersion={activityVersion}
                        activityName={title}
                        onViewAssigment={this.viewAssignment}
                        hasCredentials={hasCred}
                        missingCredentialsText={missingCredentialsText}
                        onClose={this.hideAssignmentCreateUI}
                    />
                );
            case 'mzl':
                return (
                    <LocalAssignmentCreateUI
                        activityID={activityID}
                        activityVersion={activityVersion}
                        activityName={title}
                        onViewAssigment={this.viewAssignment}
                        hasCredentials={hasCred}
                        onClose={this.hideAssignmentCreateUI}
                    />
                );
            default:
                break;
        }

        const userInfo = this.state.signInStoreState.userInfo;
        const isOwnChannel = !!userInfo && userInfo.id === parseInt(this.props.channelId);
        const isOrgChannel = Globals.users.is_org_account_type(this.props.channelStoreState.channel.channel_account_type_token);
        const accountHasAdHocAssignment = FeatureUtil.hasAdHocAssignments(channelFeatures);
        const userCanCreateAdHocAssignment = PermissionsUtil.canCreateAdHocAssignment(channelUserPermissions, projectUserPermissions);

        let createTooltipText;
        let canCreateLocalAssignment;
        if (accountHasAdHocAssignment && userCanCreateAdHocAssignment) {
            canCreateLocalAssignment = true;
        }
        else {
            canCreateLocalAssignment = false;

            if (!isOrgChannel) {
                if (isOwnChannel && !accountHasAdHocAssignment) {
                    createTooltipText = `Upgrade to a ${StringUtil.getStingForAccountType(Globals.users.account_types.INDIVIDUAL)} License to access this feature`;
                }
                else if (!isOwnChannel) {
                    createTooltipText = "You are not in your own channel (can't make assignments from other users' activities)"; //'Not available for your Project role.'
                }

            }
            else {
                if (accountHasAdHocAssignment && !userCanCreateAdHocAssignment) {
                    createTooltipText = 'Not available for your Organization or Project role.';
                }
                else if (!accountHasAdHocAssignment) {
                    createTooltipText = 'Not available for your Organization\'s license type.';
                }
            }
        }

        return (
            <div className="assignment-create-button-div">
                <span>
                    <Button title={toolTip} disabled={!canCreateLocalAssignment} onClick={this.showLocalAssignmentCreateUI}>
                        Create Assignment in Author
                    </Button>
                    {(!!createTooltipText) &&
                        <Tooltip id="tooltip-local-disabled" className="margin-left-md" placement="right">{createTooltipText}</Tooltip>
                    }
                </span>
            </div>
        );
    }

    enableShare() {
        const sharingActionId = uuid.v4();
        this.setState({ sharingActionId: sharingActionId }, () => {
            ActivityActions.modifyShareLink(sharingActionId, {
                actId: this.props.activityId,
                enableShare: true,
            });
        });
    }

    updateShareExpiration(momentDate, doChanges=false) {
        const self = this;
        this.setState({ updatedShareExpiration: momentDate, shareExpirationDirty: true }, () => {
            if (doChanges) {
                self.doShareChanges();
            }
        });
    }
    
    doShareChanges(shareEnabled=true) {
        if (shareEnabled) {
            const changes = {
                actId: this.props.activityId,
                enableShare: true,
            };

            let shareExpiresAt;
            if (this.state.shareExpirationDirty) {
                if (!!this.state.updatedShareExpiration) {
                    changes.shareExpiresAt = this.state.updatedShareExpiration.format();
                }
                else {
                    changes.shareExpiresAt = null;
                }
            }

            const sharingActionId = uuid.v4();
            this.setState({ sharingActionId: sharingActionId }, () => {
                ActivityActions.modifyShareLink(sharingActionId, changes);
            });
        }
        else {
            const sharingActionId = uuid.v4();
            this.setState({ sharingActionId: sharingActionId }, () => {
                ActivityActions.modifyShareLink(sharingActionId, {
                    actId: this.props.activityId,
                    enableShare: false,
                });
            });
        }
    }

    _showModal(modalName) { // helper in moving away from mixins (ModalMixin)
        this.setState({ modalState: { ...this.state.modalState, [modalName]: true }});
    }

    _hideModal(modalName, callback=null) { // helper in moving away from mixins (ModalMixin)
        this.setState({ modalState: { ...this.state.modalState, [modalName]: false } }, () => {
            if (typeof callback === 'function') callback();
        });
    }

    _addActionIdToModal(modalName, actionID, callback=null) { // helper in moving away from mixins (ModalMixin)
        this.setState({ modalAction: { ...this.state.modalAction, [modalName]: actionID } }, () => {
            if (typeof callback === 'function') callback();
        });
    }

    _getNewHiddenModalStateForAction(action) { // helper in moving away from mixins (ModalMixin)
        const newModalState = { ...this.state.modalState };
        if (!!action.id && !action.error) {
            forEach(this.state.modalAction, (actionID, modalName) => {
                if (actionID === action.id) {
                    newModalState[modalName] = false;
                }
            });
        }

        return newModalState;
    }

    render() {
        if (
            ! this.state.signInStoreState.initialized
            || !this.props.channelStoreState.initialized
            || !this.state.activityStoreState.initialized
            || !this.state.templateStoreState.initialized
            || !this.props.projectStoreState.initialized
        ) {
            return <div/>;
        }

        const _activity = this.state.activityStoreState.activity;
        const _editLock = this.props.activityLock;
        const _template = this.state.templateStoreState.template;
        const _project = this.props.projectStoreState.project;
        const _userInfo = this.state.signInStoreState.userInfo;
        const channel = this.props.channelStoreState.channel;
        const channelName = !!channel ? channel.name : "Channel";
        const userTimezone = Moment.tz.guess();
        const setSharedExpiration = !!_activity.share_expires_at ? TimeUtil.convertToTimeZone(_activity.share_expires_at, userTimezone) : null;
        
        var ver = verUtil.parseVersion(_activity.version);
        var unpublishedChanges = _activity.version == "1.0.0" || ver.patch !== 0;
        var hasAnyPublishes = !!_activity.latest_published_version;
        // var templateIcon = GlobalConfig.StaticUrl + '/img/templates/' + _template.icon;
        const ltiUrl = GlobalConfig.ApiUrl + "/authoring/lti";
        const lti13Url = GlobalConfig.ApiUrl + "/authoring/oidc/launch";

        //actions-----------------------------------------------------------------------------------
        let actions = [];
        const activityLocked = this.props.activityLock && this.props.activityLock.locked;
        const activityLockStale = this.props.activityLock && this.props.activityLock.lockStale;
        const canEditActivity = PermissionsUtil.canEditActivity(channel.user_permissions, _project.user_permissions);

        if (
            canEditActivity
            && (!activityLocked || activityLockStale)
        ) {
            actions.push({
                value: Strings['en'].activity.actions.EDIT,
                handler: this.edit,
                group: 0,
                //bgColor: "#cccccc"
            });
        }

        if (PermissionsUtil.canReviewActivity(channel.user_permissions, _project.user_permissions)) {
            actions.push({
                value: Strings['en'].activity.actions.REVIEW,
                handler: this.review,
                group: 0,
                //bgColor: "#cccccc",
                tooltip: Strings['en'].activity.actions.REVIEW_TT,
            });
        }

        if (PermissionsUtil.canPreviewActivity(channel.user_permissions, _project.user_permissions)) {
            actions.push({
                value: Strings['en'].activity.actions.PREVIEW,
                handler: this.preview,
                group: 0,
                //bgColor: "#cccccc",
                tooltip: Strings['en'].activity.actions.PREVIEW_TT
            });
        }

        if (!activityLocked) {
            if (unpublishedChanges && PermissionsUtil.canPublishActivity(channel.user_permissions, _project.user_permissions)) {
                actions.push({
                    value: Strings['en'].activity.actions.PUBLISH,
                    handler: this._showModal.bind(this, "publishActivity"),
                    group: 0,
                    //bgColor: "#cccccc"
                });
            }

            if (hasAnyPublishes && PermissionsUtil.canPublishActivity(channel.user_permissions, _project.user_permissions)) {
                actions.push({
                    value: Strings['en'].activity.actions.UNPUBLISH,
                    handler: this._showModal.bind(this, "unpublishActivity"),
                    group: 0,
                    //bgColor: "#cccccc"
                });
            }

            if (PermissionsUtil.canDuplicateActivity(channel.user_permissions, _project.user_permissions)) {
                actions.push({
                    value: Strings['en'].activity.actions.DUPLICATE,
                    handler: this._showModal.bind(this, "copyActivity"),
                    group: 0,
                    //bgColor: "#cccccc"
                });
            }

            if (PermissionsUtil.canRenameActivity(channel.user_permissions, _project.user_permissions)) {
                actions.push({
                    value: Strings['en'].activity.actions.RENAME,
                    handler: this._showModal.bind(this, "renameActivity"),
                    group: 0,
                    //bgColor: "#cccccc"
                });
            }

            if (PermissionsUtil.canMoveActivity(channel.user_permissions, _project.user_permissions)) {
                actions.push({
                    value: Strings['en'].activity.actions.MOVE,
                    handler: this._showModal.bind(this, "transferActivity"),
                    group: 0,
                    //bgColor: "#cccccc"
                });
            }

            if (PermissionsUtil.canDeleteActivity(channel.user_permissions, _project.user_permissions)) {
                actions.push({
                    value: Strings['en'].activity.actions.DELETE,
                    handler: this._showModal.bind(this, "archiveActivity"),
                    group: 0,
                    //bgColor: "#cccccc"
                });
            }

            if (
                FeatureUtil.hasIntegrationTags(channel.channel_permissions)
                && PermissionsUtil.canManageActivityTags(channel.user_permissions, _project.user_permissions)
            ) {
                actions.push({
                    value: Strings['en'].activity.actions.MANAGE_IT,
                    handler: this._showModal.bind(this, 'activityTags'),
                    group: 0,
                    //bgColor: '#cccccc',
                    iconClass: 'fa-tags margin-right-sm'
                });
            }

            if (
                FeatureUtil.hasActivityMetaTags(channel.channel_permissions)
                && PermissionsUtil.canViewActMetaTagsForAct(channel.user_permissions, _project.user_permissions)
            ) {
                actions.push({
                    value: Strings['en'].activity.actions.MANAGE_MT,
                    handler: this.gotoMetaTagsView,
                    group: 0,
                    //bgColor: '#cccccc',
                    iconClass: 'fa-tag margin-right-sm'
                });
            }
        }

        if (
            FeatureUtil.hasDetailedAnalytics(channel.channel_permissions)
            && PermissionsUtil.viewDetailedProjectAnalytics(channel.user_permissions, _project.user_permissions)
        ) {
            actions.push({
                value: Strings['en'].activity.actions.ANALYTICS,
                handler: this.gotoActivityAnalytics,
                group: 0,
                //bgColor: '#cccccc',
                iconClass: 'fa-bar-chart'
            });

            if (_activity.ever_published) {
                actions.push({
                    value: Strings['en'].activity.qla.QLA_TITLE_LC,
                    handler: this.gotoActivityQla,
                    group: 0,
                    iconClass: 'fa-bar-chart'
                });
            }
        }

        if (!activityLocked) {
            if (_userInfo.admin) {
                actions.push({
                    value: Strings['en'].activity.actions.IMPORT_OVER,
                    handler: this._showModal.bind(this, 'stackImport'),
                    group: 0,
                    //bgColor: "#DCEDC2",
                    iconClass: 'fa-paste'
                });
            }

            if (_userInfo.admin) {
                actions.push({
                    value: Strings['en'].activity.actions.COURSE_META,
                    handler: this._showModal.bind(this, 'shortCourseMetadata'),
                    group: 0,
                    //bgColor: "#DCEDC2",
                    iconClass: 'fa-pencil'
                });
            }

            let canUseCustomExport = false; // _userInfo.admin
            let permissions = this.state.accountFeatures;
            if (permissions && permissions[Globals.users.account_features.EDLCustomExport]) {
                canUseCustomExport = true;
            }

            if (canUseCustomExport && hasAnyPublishes) {
                let child;
                let txt = Strings['en'].activity.actions.EDL_EXPORT;
                if (this.state.customActivityExportState.pending) {
                    txt = Strings['en'].activity.actions.EDL_EXPORT_PENDING;
                    child = ( <a className="fa fa-refresh fa-spin" style={{width:"1rem"}}/> )
                }
                else if (this.state.customActivityExportState.csv_data) {
                    txt = Strings['en'].activity.actions.EDL_EXPORT_DL;
                    child = (
                        <a className="fa fa-download" style={{width:"1rem"}} 
                            title="download csv" 
                            href={this.state.customActivityExportState.csv_data.csv_url} 
                            download={`custom_edl_export_${this.state.customActivityExportState.activityId}.csv`} 
                            target="_blank"/>
                    );
                }
                else {
                    // child is version picker
                    let published_versions;
                    let saves = this.state.activityStoreState.activitySaves;
                    let published_saves = _.filter(saves,{published:true});
                    if (published_saves.length) {
                        child = (
                            <select style={{color:'black', width:'10rem'}} 
                                value={this.state.customActivityExportState.version || _activity.latest_published_version}
                                onChange={(e)=>{
                                    let customActivityExportState = {...this.state.customActivityExportState, version: e.target.value};
                                    this.setState({customActivityExportState});
                                }}
                                >
                                {published_saves.map((save,i)=>{
                                    let suffix = '';
                                    if (save.version === _activity.latest_published_version) {
                                        suffix = Strings['en'].activity.actions.EDL_EXPORT_LATEST_SUF;
                                    }
                                    return (
                                        <option key={save.version} value={save.version} title={save.version + suffix}>{save.version}</option>
                                    );
                                })}
                            </select>
                        )
                    }
                }
                actions.push({
                    value: txt,
                    handler: this.handle_EDL_export,
                    group: 0,
                    //bgColor: "#DCEDC2",
                    iconClass: 'fa-bar-chart',
                    child: child
                });
            }

        }

        // can create Google Classroom Assignment logic
        const userInfo = this.state.signInStoreState.userInfo;
        const isOwnChannel = !!userInfo && userInfo.id === parseInt(this.props.channelId, 10);
        const isOrgChannel = Globals.users.is_org_account_type(this.props.channelStoreState.channel.channel_account_type_token);
        const accountHasGoogleClassroom = FeatureUtil.hasGoogleClassroom(channel.channel_permissions);
        let canCreateGoogleClassroomAssignment = accountHasGoogleClassroom;
        let gcButtonDisabledTooltip;
        if (!isOrgChannel) {
            if (isOwnChannel && !accountHasGoogleClassroom) {
                // gcButtonDisabledTooltip = `Upgrade to a ${StringUtil.getStingForAccountType(Globals.users.account_types.INDIVIDUAL)} License to access this feature`;
                // TODO TEMPORARY: this message is purposely vague to give us the ability to switch Google Classroom permissions on & off for Individual license users
                canCreateGoogleClassroomAssignment = false;
                gcButtonDisabledTooltip = 'This feature is not available for your license type.';
            }
            else if (!isOwnChannel && accountHasGoogleClassroom) {
                canCreateGoogleClassroomAssignment = false;
                gcButtonDisabledTooltip = 'You are not in your own channel (can\'t make assignments from other users\' activities)';
            }

        }
        else {
            if (!PermissionsUtil.canCreateGoogleClassroom(channel.user_permissions, _project.user_permissions)) {
                canCreateGoogleClassroomAssignment = false;
                gcButtonDisabledTooltip = 'Not available for your Organization or Project role.';
            }

        }

        // share link logic
        const accountHasShareLinks = FeatureUtil.hasActivityShareLink(channel.channel_permissions);
        const canManageActivityShareLink = PermissionsUtil.canManageActivityShareLink(channel.user_permissions, _project.user_permissions);
        let enableShareToolTipText = '';
        if (!accountHasShareLinks) {
            if (isOwnChannel) {
                enableShareToolTipText = `Upgrade to a ${StringUtil.getStingForAccountType(Globals.users.account_types.INDIVIDUAL)} License to access this feature.`;
            }
            else {
                enableShareToolTipText = `This feature is not available for this account's license type.`;
            }
        }

        //activity locked element=================================================================
        let lockedElem = null;
        if (activityLocked) {
            let warningText;
            if (!activityLockStale) {
                let adminUnlockButton;
                if (PermissionsUtil.canAdministerAssignment(channel.user_permissions, _project.user_permissions)) {
                    adminUnlockButton = <button className="btn btn-danger force-unlock-button" onClick={this.forceUnlock}>Force Unlock</button>
                }

                warningText = !!_editLock.userName ?
                    <span>Activity Locked: {_editLock.userName} editing{adminUnlockButton}</span> :
                    <span>Activity Locked: Editing in progress{adminUnlockButton}</span>;
            }
            else {
                warningText = !!_editLock.userName ? <span>Activity Locked (Lock Expired): {_editLock.userName} was editing but lock was not released. Edit activity to unlock.</span> : <span>Activity Locked: Editing lock was not released. Edit activity to unlock.</span>;
            }

            lockedElem = <WarningBox> {warningText} </WarningBox>;
        }

        return (
            <div className="activity-page">
                <MainNav
                    onClickBrandLogo={() => Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.channelId)}
                />
                <div className="container main-container">
                    <SubNav
                        menuClasses="d-inline-block d-sm-none"
                        actions={ actions }
                        //bgColor="#BED896"
                    >
                        <BackButton backHandler={this.backHandler} />
                        <div className="view-info-container">
                            <div className="view-title">
                                {_activity.meta_data.title}
                            </div>
                            <div className="view-description">
                                {/*_template.name*/}
                                <ActivityBreadCrumbs
                                    channel={channel}
                                    project={_project}
                                    foldersFlat={this.props.channelStoreState.foldersFlat}
                                />
                            </div>
                        </div>
                    </SubNav>

                    <Row className="mzl-cs-content main-content-nav">
                        <div className="col-sm-9 col-12 main-content">
                            {/*<div className="template-icon"><img src={templateIcon}/></div>*/}
                            <div className="section">
                                <div className="value-container inline-block margin-right-15">
                                    <div className="heading">{Strings['en'].common.AUTHOR}</div>
                                    <div className="value-default-color">
                                        {isOrgChannel ?
                                            <UserDisplayName id={_activity.owner_id} />
                                            :
                                            <UserFullName id={_activity.owner_id} />
                                        }
                                    </div>
                                </div>
                                <div className="value-container inline-block margin-right-15">
                                    <div className="heading">{Strings['en'].common.CREATED}</div>
                                    <div className="value-default-color"><DateString date={_activity.created_at}/></div>
                                </div>
                                <div className="value-container inline-block margin-right-15">
                                    <div className="heading">{Strings['en'].common.LAST_UPDATED}</div>
                                    {(!!_activity.modified) ?
                                        <div className="value-default-color">
                                            <DateString date={_activity.modified} showTime />
                                        </div>
                                        :
                                        <div className="value-default-color">
                                            <DateString date={_activity.created_at} showTime />
                                        </div>
                                    }
                                </div>
                                <div className="value-container inline-block">
                                    <div className="heading">{Strings['en'].activity.TEMPLATE}</div>
                                    <div className="value-default-color">{_template.name}</div>
                                </div>
                            </div>
                            <div className="section">
                                {lockedElem}

                                {(GlobalConfig.DevMode && _userInfo.admin) &&
                                    <Button
                                        variant="warning"
                                        onClick={this.toggleDisablePolling}
                                        style={{position: 'absolute', top: '15px', right: '15px'}}
                                    >
                                        {this.state.devDisablePolling ? "DEV: Resume Polling" : "DEV: Pause Polling"}
                                    </Button>
                                }

                                <Row>
                                    <div className="value-container col-12 col-sm-6">
                                        <div className="margin-bottom-sm">
                                            <label htmlFor="act-display-name">{Strings['en'].activity.display_name.ACT_DISPLAY_NAME}</label>
                                            <Tooltip className="margin-left-sm" id="act-display-name-tooltip" placement="right">
                                                {Strings['en'].activity.display_name.DISPLAY_NAME_DESC}
                                                <ul>{Strings['en'].activity.display_name.UL_HEAD}
                                                    <li>{Strings['en'].activity.display_name.UL_1}</li>
                                                    <li>{Strings['en'].activity.display_name.UL_2}</li>
                                                </ul>
                                            </Tooltip>
                                        </div>
                                        <ActivityDisplayNameEditor
                                            inputId="act-display-name"
                                            className="margin-bottom-xl"
                                            activityId={_activity.id}
                                            projectId={_activity.project_id}
                                            channelId={_activity.owner_id}
                                            activityLocked={activityLocked}
                                            channelUserPermissions={channel.user_permissions}
                                            projectUserPermissions={_project.user_permissions}
                                        />

                                        <div className="margin-bottom-sm">
                                            <label htmlFor="act-description">{Strings['en'].activity.description.ACT_DESCRIPTION}</label>
                                            <Tooltip className="margin-left-sm" id="act-display-name-tooltip" placement="right">
                                                {Strings['en'].activity.description.ACT_DESC_DESC}
                                            </Tooltip>
                                        </div>
                                        <ActivityDescriptionEditor
                                            inputId="act-description"
                                            className="margin-bottom-xl"
                                            activityId={_activity.id}
                                            projectId={_activity.project_id}
                                            channelId={_activity.owner_id}
                                            activityLocked={activityLocked}
                                            channelUserPermissions={channel.user_permissions}
                                            projectUserPermissions={_project.user_permissions}
                                        />

                                        <div className="margin-bottom-sm">
                                            <label htmlFor="act-play-text">{Strings['en'].activity.play_button.PB_TEXT}</label>
                                            <Tooltip className="margin-left-sm" id="act-play-text-tooltip" placement="right">
                                                {Strings['en'].activity.play_button.PB_TEXT_DESC}
                                            </Tooltip>
                                        </div>
                                        <ActivityPlayButtonTextEditor
                                            inputId="act-play-text"
                                            activityId={_activity.id}
                                            projectId={_activity.project_id}
                                            channelId={_activity.owner_id}
                                            activityLocked={activityLocked}
                                            channelUserPermissions={channel.user_permissions}
                                            projectUserPermissions={_project.user_permissions}
                                        />

                                    </div>
                                    <div className="value-container col-12 col-sm-6 text-centered">
                                        <AssetImage
                                            src={this.state.activityImgUrl}
                                            alt={Strings['en'].activity.image.ALT}
                                            className="parent-constrained"
                                            aria-hidden={true}
                                        />
                                        <div className="margin-top-md margin-bottom-xl">
                                            <SingleAssetInput
                                                buttonOnly
                                                browseText={Strings['en'].activity.image.BTN_TEXT}
                                                assetType="image"
                                                assetRole="normal"
                                                accept="image/*"
                                                onChange={this.updateImage}
                                                onError={this.updateImageOnError}
                                                validateAssetType={AssetUtil.validateImageMimeType}
                                                disabled={activityLocked || !!this.state.imageUpdateActionID || !canEditActivity}
                                            />
                                        </div>
                                    </div>
                                </Row>
                            </div>

                            {(hasAnyPublishes) &&
                                <div className="section">
                                    <h2 className="title">{Strings['en'].activity.stats.ACT_STATS}</h2>
                                    <hr className="thick hr-color-fg"/>

                                    <div className="value-container inline-block margin-right-15">
                                        <div className="heading">{Strings['en'].activity.TOTAL_CREATED}</div>
                                        <div className="strong-value-default-color">
                                            {StringUtil.numberToLocaleString(this.state.activityLaunchCount)}
                                        </div>
                                    </div>
                                    <div className="value-container inline-block margin-right-15">
                                        <div className="heading">{Strings['en'].activity.TOTAL_SHARED}</div>
                                        <div className="strong-value-default-color">
                                            {StringUtil.numberToLocaleString(this.state.shareStartedTotal)}
                                        </div>
                                    </div>
                                    <div className="value-container inline-block">
                                        <div className="heading">
                                            {Strings['en'].activity.UNIQUE_SHARED_MTD}
                                            <Tooltip id="tooltip-unique-share-mtd" placement="right" className="margin-left-sm">{Strings['en'].activity.UNIQUE_SHARED_MTD_TT}</Tooltip>
                                        </div>
                                        <div className="strong-value-default-color">
                                            {StringUtil.numberToLocaleString(this.state.sharesUniqueMtd)}
                                        </div>
                                    </div>
                                    <ActivityStatsCharts
                                        avgTimePlayed={this.state.avgTimePlayed}
                                        totalCompleted={this.state.totalCompleted}
                                        timePlayedGraphData={this.state.timePlayedGraphData}
                                        completionGraphData={this.state.completionGraphData}
                                        avgScore={this.state.avgScore}
                                        scoreGraphData={this.state.scoreGraphData}
                                    />
                                </div>
                            }

                            {(hasAnyPublishes) &&
                                <div className="section">
                                    <h2 className="title">{Strings['en'].activity.share.ACT_SHARE_TITLE}</h2>
                                    <hr className="thick hr-color-fg"/>
                                    {(channel.enable_share_links) &&
                                        <div className="value-container--xlMargin">
                                            <div className="strong-heading">Share Link</div>
                                            {(!_activity.share_id || !_activity.allow_share || !accountHasShareLinks) ?
                                                <div>
                                                    <Button
                                                        onClick={this.enableShare}
                                                        disabled={!canManageActivityShareLink || !accountHasShareLinks}
                                                    >
                                                        {Strings['en'].activity.share.ENABLE_SHARE}
                                                    </Button>
                                                    {(!!enableShareToolTipText) &&
                                                        <Tooltip id="tooltip-share-disabled" className="margin-left-md" placement="right">{enableShareToolTipText}</Tooltip>
                                                    }
                                                </div>
                                                :
                                                <div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={urljoin(GlobalConfig.ApiUrl, `/share/`, _activity.share_id)}
                                                        onChange={this.noOp}
                                                        onClick={this.selectAllHandler}
                                                    />
                                                </div>
                                            }
                                            {(!!_activity.share_id && !!_activity.allow_share && accountHasShareLinks) &&
                                                <div>
                                                    <div className="value-container margin-bottom-lg">
                                                        <Button
                                                            className='margin-top-sm'
                                                            onClick={this.doShareChanges.bind(this, false)}
                                                            disabled={!!this.state.sharingActionId || !canManageActivityShareLink}
                                                        >
                                                            {Strings['en'].activity.share.DISABLE_SHARE}
                                                        </Button>
                                                    </div>
                                                    <div className="value-container margin-bottom-lg">
                                                        <DateTimePicker
                                                            id="act-share-exp"
                                                            className="dateTimePicker__actExpiration"
                                                            label={Strings['en'].activity.share.EXPIRATION_LABEL}
                                                            labelClassName="strong-heading"
                                                            date={this.state.updatedShareExpiration || setSharedExpiration || null}
                                                            onChange={this.updateShareExpiration}
                                                            timezoneDisplay={Moment.tz(TimeUtil.getParsedTimezoneName(userTimezone)).format('z')}
                                                            readOnly={!canManageActivityShareLink}
                                                        />
                                                        <Button
                                                            className='margin-top-sm'
                                                            onClick={this.doShareChanges}
                                                            disabled={!this.state.shareExpirationDirty || !!this.state.sharingActionId || !canManageActivityShareLink}
                                                            >
                                                            {Strings['en'].activity.share.UPDATE_EXPIRATION}
                                                        </Button>
                                                        {(setSharedExpiration) &&
                                                            <Button
                                                                className='margin-top-sm margin-left-md'
                                                                onClick={this.updateShareExpiration.bind(this, null, true)}
                                                                disabled={!!this.state.sharingActionId || !canManageActivityShareLink}
                                                            >
                                                                {Strings['en'].activity.share.REMOVE_EXPIRATION}
                                                            </Button>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </div>                                        
                                    }

                                    {this.renderCreateAssignmentUI(
                                        _activity.activity_id, _activity.latest_published_version, _activity.meta_data.display_name
                                        || _activity.meta_data.title, channel.user_permissions, _project.user_permissions, channel.channel_permissions
                                    )}
                                </div>
                            }

                            {(hasAnyPublishes) &&
                                <div className="section">

                                    <h2 className="title">Integration</h2>
                                    <hr className="thick hr-color-fg"/>

                                    <div className="value-container">
                                        <div className="strong-heading">Activity Id</div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={_activity.activity_id}
                                            onChange={this.noOp}
                                            onClick={this.selectAllHandler}
                                        />
                                    </div>
                                    <div className="value-container">
                                        <div className="strong-heading">LTI 1.1 Url</div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={ltiUrl}
                                            onChange={this.noOp}
                                            onClick={this.selectAllHandler}
                                        />
                                    </div>
                                    <div className="value-container">
                                        <div className="strong-heading">{'LTI 1.3 Url'}</div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={lti13Url}
                                            onChange={this.noOp}
                                            onClick={this.selectAllHandler}
                                        />
                                    </div>
                                    <div className="value-container">
                                        <div className="strong-heading">Custom Param: Activity Id (Optional)</div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={'activityid=' + _activity.activity_id}
                                            onChange={this.noOp}
                                            onClick={this.selectAllHandler}
                                        />
                                    </div>
                                    <div className="value-container">
                                        <div className="strong-heading">Custom Param: Last Published Activity Version (Optional)</div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={'activityversion=' + _activity.latest_published_version}
                                            onChange={this.noOp}
                                            onClick={this.selectAllHandler}
                                        />
                                    </div>
                                    <div className="assignment-create-button-div margin-top-xl">
                                        <button
                                            className={"btn btn-primary" + (canCreateGoogleClassroomAssignment ? '': ' disabled')}
                                            disabled={!canCreateGoogleClassroomAssignment}
                                            onClick={this.showGoogleClassroomCreateUI}
                                        >
                                            Create Assignment in Google Classroom
                                        </button>
                                        {(!!gcButtonDisabledTooltip) &&
                                            <Tooltip id="tooltip-gc-disabled" className="margin-left-md" placement="right">{gcButtonDisabledTooltip}</Tooltip>
                                        }
                                    </div>
                                </div>
                            }

                            <div className="section">
                                <h2 className="title">{Strings['en'].activity.SAVE_PUBLISH_HISTORY}</h2>
                                <hr className="thick hr-color-fg"/>
                                <ActivitySavesTable
                                    documentVisible={this.props.documentVisible}
                                    activityId={this.props.activityId}
                                    projectId={this.props.projectId}
                                    channelId={this.props.channelId}
                                    currentActivityVersion={_activity.version}
                                    disablePolling={this.state.devDisablePolling}
                                    viewValidationForVesionFunc={
                                        PermissionsUtil.canViewValidationReport(channel.user_permissions, _project.user_permissions) ?
                                            this.setValidationModalVersion
                                            :
                                            null
                                    }
                                />
                            </div>



                        </div>
                        <SideNav className="d-none d-sm-block col-sm-3 mzl-cs-secondary-button-group" actions={actions} />
                        
                    </Row>
                </div>

                {this.state.modalState["archiveActivity"] ?
                    <ConfirmModal
                        show={true}
                        text={_activity ?
                            'Are you sure you would like to delete \'' + _activity.meta_data.title  + '\'?'
                            : ''
                        }
                        closeHandler={this._hideModal.bind(this, "archiveActivity")}
                        confirmHandler={this.archiveActivityHandler}/>
                    : null
                }

                {this.state.modalState["publishActivity"] &&
                    <PublishActivityModal
                        activityLocked={activityLocked}
                        activityId={this.props.activityId}
                        projectId={this.props.projectId}
                        channelId={this.props.channelId}
                        onPostPublish={this.postPublishHandler}
                        onClose={this._hideModal.bind(this, 'publishActivity')}
                    />
                }

                {this.state.modalState["unpublishActivity"] &&
                    <ConfirmPhraseModal
                        closeHandler={this._hideModal.bind(this, "unpublishActivity")}
                        cancelHandler={this._hideModal.bind(this, "unpublishActivity")}
                        confirmButtonBsStyle="danger"
                        confirmPhrase="unpublish"
                        confirmHandler={this.onUnpublish}
                        cancelButtonText="cancel"
                        hasError={!!this.state.unpublishError}
                        message={get(this.state.unpublishError, 'responseText', null)}
                    >
                        <div className="margin-bottom-lg">
                            <p>{Strings['en'].activity.UNPUBLISH_WARNING}</p>
                        </div>
                    </ConfirmPhraseModal>
                }

                {(!!this.state.showValdiationModalForVesion) &&
                    <ActivityValidationReportModal
                        activityId={this.props.activityId}
                        projectId={this.props.projectId}
                        channelId={this.props.channelId}
                        version={this.state.showValdiationModalForVesion}
                        onClose={this.setValidationModalVersion.bind(this, null)}
                    />
                }

                {(this.state.modalState["renameActivity"]) &&
                    <SingleInputModal
                        show
                        action={this.state.activityStoreState.action}
                        childActionID={this.state.modalAction["renameActivity"]}
                        headerText="Rename Activity"
                        inputLabel="new name"
                        ariaLabel="new name"
                        buttonText="confirm"
                        defaultValue={_activity.meta_data.title}
                        closeHandler={this._hideModal.bind(this, "renameActivity")}
                        submitHandler={this.renameActivityHandler}
                    />
                }

                {(this.state.modalState["transferActivity"]) &&
                    <SelectProjectModal
                        show
                        error={this.state.transferActivityError}
                        distributionRestricted={_activity.meta_data.distributionRestricted ? true : false}
                        headerText="Move Activity"
                        buttonText="move"
                        excludeProject={this.props.projectId}
                        permissionsFunc={PermissionsUtil.canCreateNewActivity}
                        closeHandler={this._hideModal.bind(this, "transferActivity")}
                        submitHandler={this.transferActivityHandler}
                    />
                }

                {(this.state.modalState["copyActivity"]) &&
                    <CopyActivityModal
                        action={this.state.activityStoreState.action}
                        childActionID={this.state.modalAction["copyActivity"]}
                        defaultValue={_activity.meta_data.title + " Copy"}
                        projectId={this.props.projectId}
                        distributionRestricted={!!_activity.meta_data.distributionRestricted}
                        closeHandler={this._hideModal.bind(this, "copyActivity")}
                        submitHandler={this.copyActivityHandler}
                        sourceChannelId={channel.id}
                        sourceChannelHasMetaTags={FeatureUtil.hasActivityMetaTags(channel.channel_permissions)}
                    />
                }

                {this.state.modalState['activityTags'] &&
                    <ManageActivityTagsModal
                        show
                        activityId={_activity.id}
                        projectId={_project.id}
                        closeHandler={this._hideModal.bind(this, 'activityTags')}
                        orgId={this.props.channelId}
                    />
                }

                {(this.state.modalState['autosaveFound']) &&
                    <ThreeModal key="confirm" modalTitle="Autosave Found" message={this.getAutosaveMessageText()} buttonData={this.getAutosaveButtonData()} />
                }
                
                {(this.state.modalState['confirmAutosaveDelete']) &&
                    <ThreeModal key="inception" modalTitle="Autosave Found" message={this.getAutosaveMessageText(true)} buttonData={this.getAutosaveButtonData(true)} />
                }
                

                {(this.state.modalState["forceUnlock"]) &&
                    <ForceUnlockModal
                        project_id={this.props.projectId}
                        activity_id={this.props.activityId}
                        nova_act_id={_activity.activity_id}
                        userName={_userInfo.display_name}
                        lockUserName={this.state.activityStoreState.activityLock.userName}
                        closeHandler={this._hideModal.bind(this, "forceUnlock")}
                        confirmHandler={this.forceUnlockHandler}
                    />
                }

                {(this.state.modalState["stackImport"]) &&
                    <StackImportMergeModal
                        novaActId={_activity.activity_id}
                        closeHandler={this._hideModal.bind(this, 'stackImport')}
                        importStacks={this.state.importStacks}
                    />
                }
                
                {(this.state.modalState["shortCourseMetadata"]) &&
                    <ActivityShortCourseMetadataModal
                        action={this.state.activityStoreState.action}
                        childActionID={this.state.modalAction["shortCourseMetadata"]}
                        activity={this.state.activityStoreState.activity}
                        submitHandler={this.submitShortCourseMetaDataHandler}
                        closeHandler={this._hideModal.bind(this, 'shortCourseMetadata')}
                    />
                }

            </div>
        );
    }
}

ActivityView.propTypes = propTypes;
ActivityView.defaultProps = defaultProps;

const WrappedComponent = withRouter(WithChannelData(WithProjectData(WithDocumentVisible(WithActivityLockPoll(ActivityView)))));

// WithActivityData is expected the activityId prop. "Rename" props.params.activityId to props.activityId here. do the same with projectId & channelId
function WrappedComponentWithUpdatedPropNames(props) {
    return (
        <WrappedComponent
            {...props}
            activityId={props.match.params.activityId}
            projectId={props.match.params.projectId}
            channelId={props.match.params.channelId}
        />
    );
}

WrappedComponentWithUpdatedPropNames.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            channelId: PropTypes.string.isRequired,
            projectId: PropTypes.string.isRequired,
            activityId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default WrappedComponentWithUpdatedPropNames;
